import React from 'react'
import clsx from 'clsx'

interface MerchantDisplayProps {
  children: React.ReactNode
  isValue?: boolean
}

const ExpiryDisplay = ({ children, isValue }: MerchantDisplayProps) => {
  return (
    <div
      className={clsx(`flex cursor-pointer items-center gap-3 py-1`, {
        'flex-row-reverse': isValue,
      })}
    >
      {children}
    </div>
  )
}

export default ExpiryDisplay
